import CandidatesTable from './CandidatesTable'

import { useState, useEffect} from 'react';

function DisplayCandidates(props) {
    const [colNames, setColNames] = useState([])
    const [colRows, setColRows] = useState([])
    const [numSelected, setNumSelected] = useState(0)
    const [modifiedCustomDesign, setModifiedCustomDesign] = useState(false);


    useEffect( () => {  
        if(props.candidates){
            let col_names = [...props.factorNames];
            col_names.push('Strategy')
            col_names.unshift('');

            setColNames(col_names);
            setColRows(props.candidates);

            let num_selected = props.candidates.filter(row => row['selected'] === true).length;
            setNumSelected(num_selected);
        }

    }, [props.factorNames, props.candidates] );


    useEffect( () => {  
        setModifiedCustomDesign(props.modifiedCustomDesign);
    }, [props.modifiedCustomDesign] );

 
    let action_panel = []
    if (numSelected>0){
        action_panel = [{title:'Delete', action:props.handleDelete}, {title:'Replace', action:props.handleReplace}];
    }
    else {
        action_panel = [{title:'Custom Design', action:props.handleCustomDesign}];
    }

    if(modifiedCustomDesign){
        if (numSelected>0){
            action_panel = [
                // {title:'Custom Design', action:props.handleCustomDesign}, 
                            {title:'Save', action:props.handleCustomDesignSave},
                            {title:'Discard', action:props.handleCustomDesignDiscard},
                            {title:'Delete', action:props.handleDelete}, 
                            {title:'Replace', action:props.handleReplace}];
        }
        else {
            action_panel = [
                // {title:'Custom Design', action:props.handleCustomDesign},
                            {title:'Save', action:props.handleCustomDesignSave},
                            {title:'Discard', action:props.handleCustomDesignDiscard},
            ];
        }
    }



    return (<>
            <div style = {{width: `${props.width * 0.91 - 20}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '0px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'10px', width:'fit-content'}} >
                            Display Candidates 
                </h4>
                <div style = {{fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%', overflow:'auto'}}>
                    <CandidatesTable 
                        tableRows={colRows}
                        colNames={colNames}
                        actionsOnSelect={action_panel}
                        onSelect={props.onSelectCandidates}
                        itemsPerPage={15}
                        displayPrecision={props.displayPrecision}
                        handleDisplayPrecision={props.handleDisplayPrecision}
                        handleCustomDesignInput={props.handleCustomDesignInput}/>
                </div>
                <div style = {{display:'flex',marginLeft:'10px', marginBottom:'15px', marginTop:'5px', gap:'10px'}} >
                    <button className={'actionButtonSmall'} style={{width:'150px', margin:'0px', marginLeft:'0px'}} onClick={props.handleExportTableXLS} >Export Table .xlsx</button>
                    <button className={'actionButtonSmall'} style={{width:'150px', margin:'0px', marginLeft:'0px'}} onClick={props.handleExportTemplateXLS} >Export Template .xlsx</button>  
                </div>
            </div>
        </>);

}

export default DisplayCandidates;